<template>
    <ModalBase :show-modal="showModal" @close-modal="close">
        <template v-slot:titlebar>
            <TitleBar variant-class="title-modal">
                <template v-slot:title>
                    {{ $gettext('Invoice') }} <span v-if="invoice">{{ invoice.number }}</span>
                </template>
            </TitleBar>
        </template>
        <template v-slot:maincontent>
            <InvoicePDFPreview
                :is-quotation="false"
                :key="invoice.id"
                :invoice-id="invoice.id"
                ref="invoice-pdf-preview"/>
        </template>
    </ModalBase>
</template>

<script>
import { mapMutations } from 'vuex'
import TitleBar from "@/components/TitleBar"
import ModalBase from "@/components/base_components/ModalBase"
import InvoicePDFPreview from "@/components/invoices/ui/InvoicePDFPreview"

export default {
    name: "SimpleInvoiceModal",
    components: {TitleBar, ModalBase, InvoicePDFPreview},
    props: {
        invoice: {
            type: Object,
            default: () => null
        }
    },
    watch: {
        invoice(val) {
            if (val) {
                this.setInvoice(val)
                this.show()
                setTimeout(() => {this.invoiceUrl = val.pdf_file}, 100)
            } else {
                this.close()
            }
        }
    },
    data() {
        return {
            showModal: false,
            invoiceUrl: ''
        }
    },
    methods: {
        ...mapMutations({
            setInvoice: 'invoices/SET_INVOICE',
            setInvoicePDF: 'invoices/SET_INVOICE_PDF'
        }),
        show() {
            this.showModal = true
        },
        close() {
            this.invoiceUrl = ''
            this.showModal = false
            this.setInvoice(null)
            this.setInvoicePDF(null)
            this.$emit('close')
        }
    }
}
</script>